import { storeUtils, toProxy } from "@fanfanlo";

export interface ISocketSettingData{
    //如果点击开始链接了，那就保持链接，这样需要注意不在开发环境时会不停重连。
    keepConnect:boolean;
    url:string;
}

async function createDefSocketSettingData():Promise<ISocketSettingData>{
    const data =  {
        keepConnect:false,
        url:""     
     }
     const res = await storeUtils.getNamespaceStoreWithData('market-dev-socket-setting', {defData:data})
     return res.data;
}

export async function getMarketDevSocketSettingData():Promise<ISocketSettingData>{
    return await createDefSocketSettingData()
}